"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { keyFeatureTabs } from "./crm.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function KeyFeaturesTabs() {
  const $ = _c(80);
  const desktopAnimations = useDesktopAnimations();
  const [activeId, setActiveId] = useState("patients");
  let T0;
  let T1;
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activeId || $[1] !== desktopAnimations) {
    const activeTab = keyFeatureTabs.find(tab => tab.id === activeId) ?? keyFeatureTabs[0];
    t16 = "bg-[#eaf5fe] dark:bg-gray-950 py-16 md:py-24 px-4 sm:px-6 lg:px-8 font-sans overflow-hidden";
    t13 = "max-w-7xl mx-auto";
    let t17;
    if ($[21] !== desktopAnimations) {
      t17 = desktopAnimations ? {
        opacity: 0,
        y: 30
      } : false;
      $[21] = desktopAnimations;
      $[22] = t17;
    } else {
      t17 = $[22];
    }
    let t18;
    if ($[23] !== desktopAnimations) {
      t18 = desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined;
      $[23] = desktopAnimations;
      $[24] = t18;
    } else {
      t18 = $[24];
    }
    let t19;
    if ($[25] !== desktopAnimations) {
      t19 = desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      };
      $[25] = desktopAnimations;
      $[26] = t19;
    } else {
      t19 = $[26];
    }
    let t20;
    let t21;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = {
        duration: 0.6,
        ease
      };
      t21 = {
        once: true
      };
      $[27] = t20;
      $[28] = t21;
    } else {
      t20 = $[27];
      t21 = $[28];
    }
    let t22;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <br className="hidden sm:block" />;
      $[29] = t22;
    } else {
      t22 = $[29];
    }
    let t23;
    if ($[30] !== t17 || $[31] !== t18 || $[32] !== t19) {
      t23 = <motion.h2 initial={t17} whileInView={t18} animate={t19} transition={t20} viewport={t21} className="font-poppins text-2xl sm:text-3xl lg:text-[2.5rem] font-bold text-[#141047] dark:text-white mb-5 leading-tight tracking-tight">Key Features of Our Doctor OPD and {t22}Appointment Booking CRM</motion.h2>;
      $[30] = t17;
      $[31] = t18;
      $[32] = t19;
      $[33] = t23;
    } else {
      t23 = $[33];
    }
    let t24;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <p className="text-[#6b7280] dark:text-gray-400 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">Our doctor appointment booking CRM lets you schedule appointments anytime. With advanced features, it streamlines scheduling and management, helping doctors and clinics efficiently track and manage patient appointments with ease.</p>;
      $[34] = t24;
    } else {
      t24 = $[34];
    }
    if ($[35] !== t23) {
      t14 = <div className="text-center max-w-3xl mx-auto mb-10">{t23}{t24}</div>;
      $[35] = t23;
      $[36] = t14;
    } else {
      t14 = $[36];
    }
    let t25;
    if ($[37] !== activeId) {
      t25 = keyFeatureTabs.map(tab_0 => {
        const active = tab_0.id === activeId;
        return <button key={tab_0.id} type="button" role="tab" aria-selected={active} onClick={() => setActiveId(tab_0.id)} className={`cursor-pointer rounded-full px-8 py-3 text-base font-semibold transition-all duration-300 ${active ? "bg-[#00c3ff] text-white shadow-sm" : "bg-white dark:bg-gray-800 text-[#5b6b7d] dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:border-gray-300"}`}>{tab_0.label}</button>;
      });
      $[37] = activeId;
      $[38] = t25;
    } else {
      t25 = $[38];
    }
    if ($[39] !== t25) {
      t15 = <div className="flex justify-center mb-14"><div role="tablist" className="inline-flex items-center gap-2.5">{t25}</div></div>;
      $[39] = t25;
      $[40] = t15;
    } else {
      t15 = $[40];
    }
    T1 = AnimatePresence;
    t12 = "wait";
    T0 = motion.div;
    t5 = activeTab.id;
    if ($[41] !== desktopAnimations) {
      t6 = desktopAnimations ? {
        opacity: 0,
        y: 16
      } : false;
      $[41] = desktopAnimations;
      $[42] = t6;
    } else {
      t6 = $[42];
    }
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        opacity: 1,
        y: 0
      };
      t8 = {
        opacity: 0,
        y: 8
      };
      t9 = {
        duration: 0.35,
        ease
      };
      $[43] = t7;
      $[44] = t8;
      $[45] = t9;
    } else {
      t7 = $[43];
      t8 = $[44];
      t9 = $[45];
    }
    t10 = "grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center";
    let t26;
    if ($[46] !== desktopAnimations) {
      t26 = desktopAnimations ? {
        opacity: 0,
        scale: 0.95
      } : false;
      $[46] = desktopAnimations;
      $[47] = t26;
    } else {
      t26 = $[47];
    }
    let t27;
    let t28;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = {
        opacity: 1,
        scale: 1
      };
      t28 = {
        duration: 0.5
      };
      $[48] = t27;
      $[49] = t28;
    } else {
      t27 = $[48];
      t28 = $[49];
    }
    t11 = <div className="lg:col-span-6 flex justify-center"><motion.img initial={t26} animate={t27} transition={t28} src={activeTab.image} alt={activeTab.alt} className="w-full max-w-[580px] object-contain drop-shadow-xl" /></div>;
    t2 = "lg:col-span-6 flex flex-col justify-center";
    t3 = <h3 className="font-poppins text-2xl sm:text-3xl lg:text-[2.25rem] font-bold text-[#141047] dark:text-white mb-5 leading-tight tracking-tight">{activeTab.heading}</h3>;
    t4 = <p className="text-[#6b7280] dark:text-gray-400 text-base lg:text-lg mb-8 leading-relaxed">{activeTab.description}</p>;
    t0 = "flex flex-wrap gap-x-8 gap-y-6 items-center";
    t1 = activeTab.features.slice(0, 4).map(_temp);
    $[0] = activeId;
    $[1] = desktopAnimations;
    $[2] = T0;
    $[3] = T1;
    $[4] = t0;
    $[5] = t1;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t13;
    $[10] = t14;
    $[11] = t15;
    $[12] = t16;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[2];
    T1 = $[3];
    t0 = $[4];
    t1 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t13 = $[9];
    t14 = $[10];
    t15 = $[11];
    t16 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t17;
  if ($[50] !== t0 || $[51] !== t1) {
    t17 = <div className={t0}>{t1}</div>;
    $[50] = t0;
    $[51] = t1;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== t17 || $[54] !== t2 || $[55] !== t3 || $[56] !== t4) {
    t18 = <div className={t2}>{t3}{t4}{t17}</div>;
    $[53] = t17;
    $[54] = t2;
    $[55] = t3;
    $[56] = t4;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] !== T0 || $[59] !== t10 || $[60] !== t11 || $[61] !== t18 || $[62] !== t5 || $[63] !== t6 || $[64] !== t7 || $[65] !== t8 || $[66] !== t9) {
    t19 = <T0 key={t5} initial={t6} animate={t7} exit={t8} transition={t9} className={t10}>{t11}{t18}</T0>;
    $[58] = T0;
    $[59] = t10;
    $[60] = t11;
    $[61] = t18;
    $[62] = t5;
    $[63] = t6;
    $[64] = t7;
    $[65] = t8;
    $[66] = t9;
    $[67] = t19;
  } else {
    t19 = $[67];
  }
  let t20;
  if ($[68] !== T1 || $[69] !== t12 || $[70] !== t19) {
    t20 = <T1 mode={t12}>{t19}</T1>;
    $[68] = T1;
    $[69] = t12;
    $[70] = t19;
    $[71] = t20;
  } else {
    t20 = $[71];
  }
  let t21;
  if ($[72] !== t13 || $[73] !== t14 || $[74] !== t15 || $[75] !== t20) {
    t21 = <div className={t13}>{t14}{t15}{t20}</div>;
    $[72] = t13;
    $[73] = t14;
    $[74] = t15;
    $[75] = t20;
    $[76] = t21;
  } else {
    t21 = $[76];
  }
  let t22;
  if ($[77] !== t16 || $[78] !== t21) {
    t22 = <section className={t16}>{t21}</section>;
    $[77] = t16;
    $[78] = t21;
    $[79] = t22;
  } else {
    t22 = $[79];
  }
  return t22;
}
function _temp(feature) {
  return <div key={feature} className="flex items-center gap-3 sm:gap-4 shrink-0"><div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-[#00c3ff] text-white flex items-center justify-center flex-shrink-0 shadow-md"><svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3.5}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg></div><span className="whitespace-nowrap text-[#141047] dark:text-white text-base sm:text-lg font-bold tracking-tight">{feature}</span></div>;
}